import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_DETAIL_QUERY = graphql(/* GraphQL */ `
  query TsrctContractDemandDetail($id: UUID!) {
    tesseract {
      contractDemand(id: $id) {
        id
        priority
        status
        sequenceNumber
        competitiveBiddingRule {
          id
          variant
          biddingPeriodDays
          deadline
          deadlineExceeded
        }
        createdAt
        updatedAt
        responsibleUserId
        tagIds
        demandRequest {
          id
          commodityGroupId
          createdAt
          currency
          incoTermsId
          requestedAt
          totalValue
          validityPeriod {
            from
            to
          }
          lineItems {
            id
            baselinePricePerUnit
            commodityGroupId
            commodityId
            createdAt
            deliveryLocationId
            description
            minimumOrderQuantity
            quantity
            title
            unitId
          }
        }
      }
    }
  }
`);

export const DELETE_CONTRACT_DEMAND_MUTATION = graphql(/* GraphQL */ `
  mutation TsrctDeleteContractDemand($id: UUID!) {
    tesseract {
      contractDemand(id: $id) {
        delete
      }
    }
  }
`);

export const CANCEL_CONTRACT_DEMAND_MUTATION = graphql(/* GraphQL */ `
  mutation TsrctCancelContractDemand($id: UUID!, $data: TsrctContractDemandCancelInput) {
    tesseract {
      contractDemand(id: $id) {
        cancel(data: $data) {
          id
          status
          cancellationReason
          cancellationReasonText
          sourcingCases {
            id
            status
            cancellationReason
            cancellationReasonText
            createdAt
            updatedAt
            sequenceNumber
            supplier {
              id
              name
              supplierId
              contact {
                id
                firstName
                lastName
                email
                internalId
              }
            }
            quote {
              id
              currency
              totalValue
              totalDiscountedValue
              discount
            }
            issues {
              id
              status
              variant
            }
          }
        }
      }
    }
  }
`);
